import dynamic from 'next/dynamic';
import React from 'react';
interface SvgIconProps {
  filename: string;
  alt: string;
}

const SVG_MAP = {
  'shopping-cart': dynamic(() => import(/* webpackChunkName: 'menu-items-svg' */ '@/components/global/svg/menu-icons/shopping-cart.svg')),
  star: dynamic(() => import(/* webpackChunkName: 'menu-items-svg' */ '@/components/global/svg/menu-icons/star.svg')),
  university: dynamic(() => import(/* webpackChunkName: 'menu-items-svg' */ '@/components/global/svg/menu-icons/book.svg')),
  info: dynamic(() => import(/* webpackChunkName: 'menu-items-svg' */ '@/components/global/svg/menu-icons/info.svg')),
};

type SvgKey = keyof typeof SVG_MAP;

const SvgIcon: React.FC<SvgIconProps> = ({ filename, alt }) => {
  const SvgComponent = SVG_MAP[filename as SvgKey];

  if (!SvgComponent) {
    console.error('SVG not found for:', filename);
    return null;
  }

  return <SvgComponent height={14} width={14} />;
};

export default SvgIcon;
